module.exports = __webpack_public_path__ + "img/Bn3.965d9a75.png";